export const API_ADMIN_GET_ALL_SAMPLE_TYPE = 'API_ADMIN_GET_ALL_SAMPLE_TYPE';
export const API_ADMIN_GET_ALL_SAMPLE_TYPE_SUCCESS = 'API_ADMIN_GET_ALL_SAMPLE_TYPE_SUCCESS';
export const API_ADMIN_GET_ALL_SAMPLE_TYPE_FAIL = 'API_ADMIN_GET_ALL_SAMPLE_TYPE_FAIL';

export const API_ADMIN_GET_SAMPLE_TYPE = 'API_ADMIN_GET_SAMPLE_TYPE';
export const API_ADMIN_GET_SAMPLE_TYPE_SUCCESS = 'API_ADMIN_GET_SAMPLE_TYPE_SUCCESS';
export const API_ADMIN_GET_SAMPLE_TYPE_FAIL = 'API_ADMIN_GET_SAMPLE_TYPE_FAIL';

export const API_ADMIN_PATCH_SAMPLE_TYPE = 'API_ADMIN_PATCH_SAMPLE_TYPE'
export const API_ADMIN_PATCH_SAMPLE_TYPE_SUCCESS = 'API_ADMIN_PATCH_SAMPLE_TYPE_SUCCESS'
export const API_ADMIN_PATCH_SAMPLE_TYPE_FAIL = 'API_ADMIN_PATCH_SAMPLE_TYPE_FAIL'

export const API_ADMIN_POST_SAMPLE_TYPE = 'API_ADMIN_POST_SAMPLE_TYPE'
export const API_ADMIN_POST_SAMPLE_TYPE_SUCCESS = 'API_ADMIN_POST_SAMPLE_TYPE_SUCCESS'
export const API_ADMIN_POST_SAMPLE_TYPE_FAIL = 'API_ADMIN_POST_SAMPLE_TYPE_FAIL'

export const API_ADMIN_DELETE_SAMPLE_TYPE = 'API_ADMIN_DELETE_SAMPLE_TYPE'
export const API_ADMIN_DELETE_SAMPLE_TYPE_SUCCESS = 'API_ADMIN_DELETE_SAMPLE_TYPE_SUCCESS'
export const API_ADMIN_DELETE_SAMPLE_TYPE_FAIL = 'API_ADMIN_DELETE_SAMPLE_TYPE_FAIL'

export const RESET_SAMPLE_TYPE = 'RESET_SAMPLE_TYPE';

export const SET_SAMPLE_TYPE = 'SET_SAMPLE_TYPE';

export const ADMIN_INIT_NEW_SAMPLE_TYPE = 'ADMIN_INIT_NEW_SAMPLE_TYPE'

export const ADMIN_RESET_FOCUS_SAMPLE_TYPE = 'ADMIN_RESET_FOCUS_SAMPLE_TYPE'